<template>
  <BaseCardV2
    titre="Découverte"
    has-help
    :has-btn-action="false"
    class="card px-2"
    @on-help="isOpenModalHelp = true"
  >
    <div class="d-flex flex-column align-center">
      <img
        width="160"
        height="126"
        src="@/assets/Illustration-accueil.png"
      >

      <div class="d-flex flex-column align-center my-5">
        <span class="intro text-center">Nous sommes heureux de vous accueillir dans l'espace de pilotage de vos cultures.
        </span>
        <span class="intro text-center">En débutant votre activité cultures avec la coopérative (par un apport, un contrat,...),</span>
        <span class="intro text-center"> vous découvrirez votre tableau de bord.</span>
        <span class="secondary--text mt-2 titre-h4">C'est un outil gratuit, accessible à tous.
        </span>
      </div>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      :is-open-modal-help="isOpenModalHelp"
      titre="Bienvenue"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>
            Retrouvez ici le détail de vos contrats, de vos apports, de vos cultures ainsi que la possibilité de se comparer aux autres adhérents de la coopérative sur chacune de ces thématiques.
            Vous disposerez également d'un simulateur de prix d'équilibre pour vous aider dans le pilotage de votre exploitation.
          </p>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import HelpModal from '@/components/modal/help-modal.vue'


export default {
  name: 'Decouverte',
  components: { BaseCardV2,HelpModal },
  data () {
    return {

      isOpenModalHelp: false
    }
  }

}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}

</style>
